import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import Text from '../Text';
import styles from './Tooltip.css';
var cx = classnames.bind(styles);
export default function Tooltip(_ref) {
  var bordered = _ref.bordered,
      className = _ref.className,
      icon = _ref.icon,
      inverse = _ref.inverse,
      content = _ref.content;
  return React.createElement(Text, {
    className: cx('icon', {
      bordered: bordered
    }, className)
  }, React.createElement(FontAwesomeIcon, {
    icon: icon
  }), React.createElement(Text, {
    className: cx('content', {
      inverse: inverse
    })
  }, content));
}
Tooltip.propTypes = {
  bordered: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.element.isRequired,
  inverse: PropTypes.bool,
  content: PropTypes.element.isRequired
};
Tooltip.defaultProps = {
  bordered: true,
  className: undefined,
  inverse: false
};